import axios from "axios";
import { showAlert, handleRequestError } from "../../utils/alert";

export default () => ({
  // State indicating if data is being fetched
  isLoading: true,

  // Holds all system toggle states dynamically mapped from the API
  settings: {},

  /**
   * Initialize the component, set up auth headers and fetch data.
   */
  async initSettings() {
    const token = localStorage.getItem("admin_jwt_token");
    if (!token) {
      window.location.href = "/admin/login";
      return;
    }

    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    await this.fetchSettings();
  },

  /**
   * Fetch current configurations from the database.
   */
  async fetchSettings() {
    this.isLoading = true;

    try {
      const response = await axios.get("/api/admin/settings");
      const data = response.data.data;

      // Dynamically map all boolean settings from the DB to Alpine.js state
      for (const [key, value] of Object.entries(data)) {
        this.settings[key] = value === "true";
      }
    } catch (error) {
      handleRequestError(
        error,
        "Falha ao carregar as configurações do sistema.",
      );
    } finally {
      this.isLoading = false;
    }
  },

  /**
   * Submit the updated toggle state to the API and restart queue workers.
   *
   * @param {string} key The configuration key being updated
   */
  async toggleSetting(key) {
    // Because of x-model, this.settings[key] already contains the NEW value
    const currentValue = this.settings[key];

    try {
      await axios.put("/api/admin/settings", {
        key: key,
        value: currentValue ? "true" : "false",
      });

      showAlert(
        "Serviço atualizado. As filas de processamento foram reiniciadas automaticamente.",
        "success",
      );
    } catch (error) {
      // Revert the UI toggle state immediately if the API request fails
      this.settings[key] = !currentValue;
      handleRequestError(error, "Erro ao alterar a configuração do sistema.");
    }
  },
});
